export type DigitalCollectionId =
  | "perceptions"
  | "morning-routine"
  | "studio"
  | "animals"
  | "abstract"
  | "music-collabs";

export type LocalizedCopy = { en: string; he: string };

/** Digital gallery collections — album collabs & standalone works. */
export const digitalCollectionCopy: Record<DigitalCollectionId, LocalizedCopy> =
  {
    perceptions: {
      en: "Perceptions — Dan Schachter",
      he: "Perceptions — דן שכטר",
    },
    "morning-routine": {
      en: "Morning Routine",
      he: "שגרת בוקר",
    },
    studio: {
      en: "Studio",
      he: "סטודיו",
    },
    animals: {
      en: "Animals",
      he: "חיות",
    },
    abstract: {
      en: "Abstract",
      he: "אבסטרקט",
    },
    "music-collabs": {
      en: "Music Collabs",
      he: "שיתופי מוזיקה",
    },
  };

export const digitalCollectionFilterIds = [
  "all",
  "perceptions",
  "morning-routine",
  "studio",
  "animals",
  "abstract",
  "music-collabs",
] as const;

export type DigitalCollectionFilterId =
  (typeof digitalCollectionFilterIds)[number];
